import { useState } from "react";
import {
  APL_LINK,
  login_to_superadmin,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { useNavigate } from "react-router-dom";
import { storeData } from "../../LocalConnection/LocalConnection";
import { Turnstile } from "@marsidev/react-turnstile"; // Import Turnstile

export default function LoginForm() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [turnstileToken, setTurnstileToken] = useState(""); // State for Turnstile token

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!turnstileToken) {
      newErrors.turnstile = "Please complete the verification";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleTurnstileSuccess = (token) => {
    setTurnstileToken(token);
    setErrors((prev) => ({ ...prev, turnstile: "" }));
  };

  const handleTurnstileError = () => {
    setTurnstileToken("");
    setErrors((prev) => ({ ...prev, turnstile: "Verification failed. Please try again." }));
  };

  const handleTurnstileExpire = () => {
    setTurnstileToken("");
    setErrors((prev) => ({ ...prev, turnstile: "Verification expired. Please try again." }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    const fd = new FormData();
    fd.append("useremail", formData.email);
    fd.append("userpassword", formData.password);
    fd.append("cf-turnstile-response", turnstileToken); // Add Turnstile token

    try {
      const Response = await server_post_data(login_to_superadmin, fd);
      let Response_data = Response.data.message.data_admin;
      let Response_designation = Response.data.message.data_designation;
      let data_admin_image = Response.data.message.data_admin_image;
      storeData("admin_id", Response_data.primary_id);
      storeData("admin_name", Response_data.admin_name);
      let show_mr = "";
      if (Response_data.admin_gender === "Male") {
        show_mr = "Mr. ";
      } else if (Response_data.admin_gender === "Female") {
        show_mr = "Ms. ";
      }
      storeData("admin_name_with_gender", show_mr + Response_data.admin_name);
      storeData("admin_email", Response_data.admin_email);
      storeData("admin_designation", Response_data.admin_designation);
      storeData(
        "admin_image",
        APL_LINK + data_admin_image + Response_data.admin_image
      );
      storeData("designation_name", Response_designation.designation_name);
      storeData("access_permission", Response_designation.access_permission);
      navigate("/stations");
    } catch (error) {
      console.error("Login error:", error);
      setErrors({ general: "Login failed. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-sm border border-gray-200">
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            Welcome Back
          </h2>
          <p className="text-sm text-gray-600">
            Please sign in to your account
          </p>
        </div>

        {/* Error Message */}
        {errors.general && (
          <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200">
            <p className="text-sm text-red-600">{errors.general}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Email Field */}
          <div>
            <label htmlFor="email" className="block text-sm font-medium mb-2">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`w-full border px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.email ? "border-red-500" : "border-gray-300"
              }`}
              placeholder="Enter your email"
            />
            {errors.email && (
              <p className="text-sm text-red-500 mt-1">{errors.email}</p>
            )}
          </div>

          {/* Password Field */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium mb-2"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={`w-full border px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.password ? "border-red-500" : "border-gray-300"
              }`}
              placeholder="Enter your password"
            />
            {errors.password && (
              <p className="text-sm text-red-500 mt-1">{errors.password}</p>
            )}
          </div>

          {/* Turnstile Widget */}
          <div>
            <Turnstile
              siteKey="0x4AAAAAABtNPTCi8-WQ14ea" // Replace with your Cloudflare Turnstile site key
              onSuccess={handleTurnstileSuccess}
              onError={handleTurnstileError}
              onExpire={handleTurnstileExpire}
              theme="light" // or "dark" based on your design
 fees            size="normal" // or "compact" based on your preference
            />
            {errors.turnstile && (
              <p className="text-sm text-red-500 mt-1">{errors.turnstile}</p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading || !turnstileToken}
            className={`w-full inline-flex items-center justify-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-[var(--primary-hover)] transition duration-200 ${
              isLoading || !turnstileToken ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isLoading && (
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            )}
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}